import { useSearchParams } from 'react-router-dom'

const REASON_MESSAGES: Record<string, string> = {
  domain_denied: 'That Google account is not allowed to access the admin console.',
  not_an_admin: 'That email is not registered as an admin user. Ask an existing admin to add you.',
  google_failed: 'Google Sign-In failed. Please try again.',
  invalid: 'The sign-in link was invalid or expired. Please try again.',
  error: 'Something went wrong signing you in. Please try again.',
}

export function AuthErrorScreen() {
  const [params] = useSearchParams()
  const reason = params.get('reason') ?? 'error'
  const message = REASON_MESSAGES[reason] ?? REASON_MESSAGES.error

  return (
    <div
      className="flex flex-col items-center justify-center"
      style={{ minHeight: '100svh', background: 'var(--color-surface-base)', padding: 'var(--spacing-6)' }}
    >
      <img
        src={`${import.meta.env.BASE_URL}zota-logo.svg`}
        alt="Zota"
        style={{ height: '24px', width: 'auto', marginBottom: 'var(--spacing-8)' }}
      />
      <p
        style={{
          fontFamily: 'var(--font-body)',
          fontSize: 'var(--text-body-md)',
          color: 'var(--color-error-text)',
          textAlign: 'center',
          maxWidth: '420px',
          marginBottom: 'var(--spacing-6)',
        }}
      >
        {message}
      </p>
      <a
        href="/api/v1/admin/auth/google"
        style={{
          fontFamily: 'var(--font-body)',
          fontSize: 'var(--text-body-sm)',
          fontWeight: 'var(--weight-semibold)',
          color: 'var(--color-action-primary)',
          textDecoration: 'none',
        }}
      >
        Try again
      </a>
    </div>
  )
}
